<template>
    <b-navbar toggleable="lg" type="dark" variant="dark">
        <div class="container-fluid">
            <b-navbar-brand href="javascript:" @click="goHome">
                Platform Tag Manager v1.0
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">

                    <b-nav-item-dropdown right>
                        <!-- Using 'button-content' slot -->
                        <template #button-content>
                            <em>{{user.name}}</em>
                        </template>
                        <b-dropdown-item href="javascript:" @click="logOut">Sign Out</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </div>
    </b-navbar>
</template>

<script>
import AuthService from '../../services/AuthService'

export default {
  name: 'AppHeader',
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    goHome () {
      this.$router.push('/')
    },
    logOut () {
      const authService = new AuthService()
      authService
        .signOut()
        .finally(() => {
          this.$router.push('login')
        })
    }
  }
}
</script>

<style scoped>

</style>
